module.exports = new __parcel__URL__("stakeholders-skeleton.tpl.a7968e44.svg").toString();